<div class="pt-6">
  <aiwyn-logo [height]="60" [extraClasses]="'client-logo'" (click)="goBack()"></aiwyn-logo>
</div>

<div class="authentication-body">
  <div class="w-100 text-center">
    <h2>Sign in without your password</h2>
    <p class="mt-2">We'll email you a link for password-free sign in</p>
  </div>

  <form [formGroup]="resetPasswordForm" name="resetPasswordForm" novalidate>
    <div class="position-relative w-100">
      <input
        formControlName="email"
        type="email"
        name="email"
        placeholder="Email address"
        class="form-input pe-8"
        [class.form-input--invalid]="canShowValidationErrors(resetPasswordForm?.controls.email, true, true) || userEmailError()"
      />

      <div class="form-control__post-icon">
        <aiwyn-icon name="envelope"></aiwyn-icon>
      </div>
    </div>

    <mat-error *ngIf="canShowValidationErrors(resetPasswordForm?.controls.email, true, true) || userEmailError()">
      A valid email is required
    </mat-error>

    <button
      id="continueButton"
      type="submit"
      andButton
      size="large"
      color="primary"
      class="mt-6"
      [isLoading]="isLoginEmailSending$ | async"
      (click)="signInWithEmailLink()"
    >
      Continue
    </button>

    <p class="my-3 text-center">OR</p>

    <button
      id="resetPasswordButton"
      type="button"
      andButton
      size="large"
      color="secondary"
      [isLoading]="isResetPasswordEmailSending$ | async"
      (click)="resetPassword()"
    >
      Reset Your Password
    </button>
  </form>
</div>

<app-full-client-portal-footer class="px-6 pb-6"></app-full-client-portal-footer>
